// import { coupons, discount_code } from 'app.config';
// import BlackFridaySale from 'container/components/BlackFridaySale/BlackFridaySale';
// import CyberMondaySale from 'container/components/CyberMondaySale/CyberMondaySale';
import { welcome_discount_code } from 'app.config';
import React from 'react';
import { useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';

function UpgradePrompt({ plan, onClick }) {
  const user = useSelector(state => state.auth.user);
  const isOpen = useSelector(state => state.utils.isRightSideBarOpen);
  const planLoading = useSelector(state => state.subscription.planLoading);
  const dLoading = useSelector(state => state.auth.dLoading);
  // const planData = useSelector(state => state.subscription.planData);
  const params = new URLSearchParams(window.location.search);
  const discountCode = params.get('discount_code');

  const handleRenderText = () => {
    if (user?.profile?.status === 2) {
      if (plan === 'month') {
        if (discountCode === welcome_discount_code) {
          return `Upgrade for $70/yr`;
        } else {
          return `Upgrade for $90/yr`;
        }
      } else {
        return `Manage your package`;
      }
    } else {
      if (discountCode === welcome_discount_code) {
        return `Upgrade for $7/mo`;
      } else {
        return `Upgrade for $9/mo`;
      }
    }
  };

  return (
    <React.Fragment>
      {/* {planData?.plan.toLowerCase() === 'free' && isOpen ? (
        // <BlackFridaySale onClick={onClick} />
        <CyberMondaySale onClick={onClick} />
      ) : ( */}
      <div
        className='signup__prompts'
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <div
          className='signup__prompts-grid'
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: '10px',
          }}
        >
          {planLoading || dLoading ? (
            <ClipLoader size={15} color='#ffffff' />
          ) : (
            <div style={{ display: 'flex' }}>
              <svg
                width='14'
                height='17'
                viewBox='0 0 14 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M7.28068 0.422266C7.19225 0.385596 7.09528 0.365356 6.99359 0.365356C6.8919 0.365356 6.79493 0.385596 6.7065 0.422266C6.61804 0.458865 6.53517 0.513119 6.46326 0.585026L3.18121 3.86708C2.88832 4.15997 2.88832 4.63484 3.18121 4.92774C3.4741 5.22063 3.94898 5.22063 4.24187 4.92774L6.24359 2.92602V11.782C6.24359 12.1962 6.57938 12.532 6.99359 12.532C7.4078 12.532 7.74359 12.1962 7.74359 11.782V2.92602L9.74531 4.92774C10.0382 5.22063 10.5131 5.22063 10.806 4.92774C11.0989 4.63484 11.0989 4.15997 10.806 3.86708L7.52392 0.585026C7.45201 0.513119 7.36914 0.458865 7.28068 0.422266ZM1.25 15.1346C0.835786 15.1346 0.5 15.4704 0.5 15.8846C0.5 16.2988 0.835786 16.6346 1.25 16.6346H12.7372C13.1514 16.6346 13.4872 16.2988 13.4872 15.8846C13.4872 15.4704 13.1514 15.1346 12.7372 15.1346H1.25Z'
                  fill='white'
                />
              </svg>
              {isOpen && <p>{handleRenderText()}</p>}
            </div>
          )}
        </div>
      </div>
      {/* )} */}
    </React.Fragment>
  );
}

export default UpgradePrompt;
